import { useTranslation } from 'react-i18next';
import { MouseEventHandler } from 'react';

import { Text } from 'components/library';
import { ArrowLeft, Cross } from 'components/Icon';
import RoundButton from 'components/BackButton';

import * as S from './styled';

type Props = {
  onClose: MouseEventHandler<HTMLButtonElement> & (() => void);
  onBack?: MouseEventHandler<HTMLButtonElement> & (() => void);
};
const ModalHeader = ({ onClose, onBack }: Props) => {
  const { t } = useTranslation();

  return (
    <S.Container>
      {onBack && (
        <S.ReturnBack>
          <RoundButton onClick={onBack} badgeColor="text-main" backgroundColor="surface-secondary">
            <ArrowLeft />
          </RoundButton>
        </S.ReturnBack>
      )}
      <Text center type="large-text">
        {t('subscription.text.cancel')}
      </Text>
      <S.CloseButton>
        <RoundButton onClick={onClose} badgeColor="text-main" backgroundColor="surface-secondary">
          <Cross color="text-main" />
        </RoundButton>
      </S.CloseButton>
    </S.Container>
  );
};

export default ModalHeader;
